import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})

export class AuthService {
    constructor(
        private http : HttpClient,
    ){ }

    login(payload: any): Observable<any> {
        return this.http.post(`${environment.API_URL}/xmkt/v1/merchants/login`, payload).pipe(retry(3))
    }

    createProduct(payload: any): Observable<any> {
        return this.http.post(`${environment.BUSINESS_API_URL}/products`, payload).pipe(retry(3))
    }

    createAccount(payload: any): Observable<any> {
        return this.http.post(`${environment.BUSINESS_API_URL}/merchant/wallet`, payload).pipe(retry(3))
    }

    authenticateUser(id: string): Observable<any> {
        return this.http.get(`${environment.API_URL}/xmkt/v1/merchants/login/${id}`).pipe(retry(3))
    }

}